import { render, staticRenderFns } from "./Selector.vue?vue&type=template&id=2de841a4"
import script from "./Selector.vue?vue&type=script&lang=ts"
export * from "./Selector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports